var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("header", [_c("Breadcrumb")], 1)
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("get.PriceDiscountTransaction.Code")) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Code))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("get.PriceDiscountTransaction.Description")
                      ) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Description1))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("get.PriceDiscountTransaction.Status")) +
                        ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusId
                          ? _vm.$t("insert.active")
                          : _vm.$t("insert.passive")
                      )
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("get.RmaOrder.RmaOrder"), active: "" } },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TCIBreak1,
                                "object",
                                "get.PriceDiscountTransaction.TciBreak1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TransactionDate,
                                "date",
                                "get.PriceDiscountTransaction.TransactionDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.TransactionTime,
                                "text",
                                "get.PriceDiscountTransaction.TransactionTime"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.DiscountReason,
                                "object",
                                "get.PriceDiscountTransaction.DiscountReason"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.PriceDiscountAmount,
                                "text",
                                "get.PriceDiscountTransaction.PriceDiscountAmount"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Currency,
                                "object",
                                "get.PriceDiscountTransaction.Currency"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BudgetAmount,
                                "text",
                                "get.PriceDiscountTransaction.BudgetAmount"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BudgetConsumption,
                                "text",
                                "get.PriceDiscountTransaction.BudgetConsumption"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Budget,
                                "object",
                                "get.PriceDiscountTransaction.Budget"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ApproveState,
                                "object",
                                "get.PriceDiscountTransaction.ApproveState"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ErpCode,
                                "text",
                                "get.PriceDiscountTransaction.ErpCode"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ExpirationDate,
                                "date",
                                "get.PriceDiscountTransaction.ExpirationDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.BeginDate,
                                "date",
                                "get.PriceDiscountTransaction.BeginDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Genexp1,
                                "text",
                                "get.PriceDiscountTransaction.Genexp1"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.GainType,
                                "object",
                                "get.PriceDiscountTransaction.GainType"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-015eb2bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-015eb2bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PriceDiscountTransaction/get.vue
// module id = null
// module chunks = 